import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { api, inr } from "../lib/api";
import { PageShell, Loader } from "../components/SiteChrome";

const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

export default function Account() {
  const { user, logout } = useAuth();
  const { items, lastAdded, setDrawerOpen, count } = useCart();
  const navigate = useNavigate();
  const [orders, setOrders] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (user === false) navigate("/login");
  }, [user, navigate]);

  useEffect(() => {
    if (!user) return;
    api.get("/orders/my").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
    api.get("/products").then(({ data }) => setProducts(data)).catch(() => {});
  }, [user]);

  if (!user) return <PageShell><Loader /></PageShell>;

  const lastProduct = products.find((p) => p.product_id === lastAdded);

  return (
    <PageShell kicker="My account" title={`Hi, ${(user.name || user.email).split(" ")[0]}.`}
      sub="Your orders, your cart, right where you left them.">
      <div className="acct-wrap" data-testid="account-page">
        {lastProduct && (
          <div className="acct-card fade-up" data-testid="last-added-card">
            <h3>Last thing you added</h3>
            <div className="order-row" style={{ borderBottom: 0, padding: 0 }}>
              <span style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <span className="sw" style={{ width: 38, height: 38, borderRadius: 9, display: "inline-block",
                  background: `radial-gradient(circle at 32% 28%,#F4F1E8,${lastProduct.sw})` }} />
                <span>
                  <b style={{ fontWeight: 400 }}>{lastProduct.name}</b>
                  <span style={{ display: "block", fontSize: 11, color: "var(--ink-dim)" }}>
                    {items[lastAdded] ? `${items[lastAdded]} in your cart` : "not in your cart right now"} · {inr(lastProduct.price)}
                  </span>
                </span>
              </span>
              <button className="kbtn ghost" style={{ width: "auto", height: 40, padding: "0 20px" }}
                onClick={() => setDrawerOpen(true)} data-testid="last-added-open-cart">
                Open cart{count > 0 ? ` (${count})` : ""}
              </button>
            </div>
          </div>
        )}

        <div className="acct-card fade-up" data-testid="account-orders-section">
          <h3>Orders</h3>
          {!orders ? <Loader /> : orders.length === 0 ? (
            <p style={{ color: "var(--ink-dim)", fontSize: 14 }} data-testid="no-orders-msg">
              No orders yet. <Link to="/shop" style={{ color: "var(--gold-soft)" }}>Pick a tin</Link> to get started.
            </p>
          ) : (
            orders.map((o) => (
              <div className="order-row" key={o.order_id} data-testid={`order-row-${o.order_id}`}>
                <span>
                  <span className="oid">{o.order_id}</span>
                  <span className="odate" style={{ display: "block" }}>{fmtDate(o.created_at)}</span>
                </span>
                <span className="oitems">{o.items.map((i) => `${i.name} × ${i.qty}`).join(" · ")}</span>
                <span style={{ color: "var(--cream)" }}>{inr(o.amount)}</span>
                <span className={`st ${o.status}`}>{o.status}</span>
              </div>
            ))
          )}
        </div>

        <div className="acct-card fade-up">
          <h3>Profile</h3>
          <p style={{ color: "var(--ink-dim)", fontSize: 14, margin: "0 0 18px" }}>
            {user.name} · {user.email}
          </p>
          <button className="kbtn ghost" style={{ width: "auto" }} data-testid="logout-btn"
            onClick={async () => { await logout(); navigate("/"); }}>
            Sign out
          </button>
        </div>
      </div>
    </PageShell>
  );
}
